import { Typography, Box, BoxProps } from '@mui/material'
import React from 'react'

interface IContainerProps extends Omit<BoxProps, 'title'> {
  title?: string | React.ReactNode
}

const Container = ({ children, title, ...rest }: IContainerProps) => {
  return (
    <Box className="content" {...rest}>
      {typeof title === 'string' ? (
        <Typography variant="h4" fontFamily="Roboto" mb={4} fontWeight={800}>
          {title}
        </Typography>
      ) : (
        title
      )}
      {children}
    </Box>
  )
}

export default Container
